module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['vue-app', 'vue-page-' + _vm.$route.name],
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "mdl-layout mdl-js-layout mdl-layout--fixed-header"
  }, [(_vm.top_menu) ? _c('header', {
    staticClass: "mdl-layout__header"
  }, [_c('div', {
    staticClass: "mdl-layout__header-row"
  }, [(!(_vm.$route.params.code && _vm.isApiReport())) ? _c('span', {
    staticClass: "mdl-layout-title",
    class: [_vm.$root.ui.isLoading() ? 'spinner' : ''],
    domProps: {
      "textContent": _vm._s(_vm.top_menu.title)
    }
  }) : _c('span', {
    staticClass: "mdl-layout-title",
    class: [_vm.$root.ui.isLoading() ? 'spinner' : ''],
    domProps: {
      "textContent": _vm._s(_vm.translate('Nøytral takst fra') + ' Autotaksering AS')
    }
  }), _vm._v(" "), (_vm.isReportPage()) ? [(_vm.report.report_language == 'no' && !(_vm.$route.params.code && _vm.isApiReport())) ? _c('span', {
    staticClass: "mdl-layout-title report-language"
  }, [_vm._v("- Norsk rapport")]) : (_vm.report.report_language == 'en' && !(_vm.$route.params.code && _vm.isApiReport())) ? _c('span', {
    staticClass: "mdl-layout-title report-language"
  }, [_vm._v("- Engelsk rapport")]) : (_vm.report.report_language == 'da' && !(_vm.$route.params.code && _vm.isApiReport())) ? _c('span', {
    staticClass: "mdl-layout-title report-language"
  }, [_vm._v("- Dansk rapport")]) : (_vm.report.report_language == 'sv' && !(_vm.$route.params.code && _vm.isApiReport())) ? _c('span', {
    staticClass: "mdl-layout-title report-language"
  }, [_vm._v("- Svensk rapport")]) : _vm._e()] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mdl-layout-spacer"
  }), _vm._v(" "), (!_vm.$root.isGuest()) ? _c('nav', {
    staticClass: "mdl-navigation mdl-layout--large-screen-only"
  }, [_vm._l((_vm.top_menu.items), function(item) {
    return [_c('a', {
      staticClass: "mdl-navigation__link mdl-menu__item--full-bleed-divider",
      attrs: {
        "href": item.link
      }
    }, [_c('i', {
      staticClass: "material-icons",
      domProps: {
        "textContent": _vm._s(item.icon)
      }
    }, [_vm._v("assignment_ind")]), _vm._v(" "), _c('span', {
      domProps: {
        "textContent": _vm._s(_vm.translate(item.title))
      }
    })])]
  })], 2) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (!_vm.$root.isGuest() && _vm.left_menu) ? _c('div', {
    staticClass: "mdl-layout__drawer"
  }, [(_vm.left_menu.title) ? _c('span', {
    staticClass: "mdl-layout-title",
    domProps: {
      "textContent": _vm._s(_vm.left_menu.title)
    }
  }) : _vm._e(), _vm._v(" "), _c('nav', {
    staticClass: "mdl-navigation"
  }, [_vm._l((_vm.left_menu.items), function(item) {
    return [_c('a', {
      staticClass: "mdl-navigation__link",
      attrs: {
        "href": item.link
      },
      on: {
        "click": _vm.menuItemClick
      }
    }, [_c('i', {
      staticClass: "material-icons",
      domProps: {
        "textContent": _vm._s(item.icon)
      }
    }, [_vm._v("assignment_ind")]), _vm._v(" "), _c('span', {
      domProps: {
        "textContent": _vm._s(_vm.translate(item.title))
      }
    })])]
  }), _vm._v(" "), _c('a', {
    staticClass: "mdl-navigation__link"
  }), _vm._v(" "), _vm._l((_vm.left_menu.report_items), function(item) {
    return [_c('a', {
      staticClass: "mdl-navigation__link",
      attrs: {
        "href": item.link
      },
      on: {
        "click": _vm.menuItemClick
      }
    }, [_c('i', {
      staticClass: "material-icons",
      domProps: {
        "textContent": _vm._s(item.icon)
      }
    }, [_vm._v("assignment_ind")]), _vm._v(" "), _c('span', {
      domProps: {
        "textContent": _vm._s(_vm.translate(item.title))
      }
    })])]
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.$root.ui.isLoading('pageLoading')) ? _c('div', {
    staticClass: "loadingMarker"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "duration": {
        enter: 1000,
        leave: 0
      },
      "name": "pt"
    }
  }, [_c('router-view', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$root.ui.isLoading('pageLoading')),
      expression: "!$root.ui.isLoading('pageLoading')"
    }]
  })], 1)], 1), _vm._v(" "), _c('vue-easy-lightbox', {
    attrs: {
      "escDisabled": "",
      "moveDisabled": "",
      "visible": _vm.$root.lightbox.visible,
      "imgs": _vm.$root.lightbox.imgs,
      "index": _vm.$root.lightbox.index
    },
    on: {
      "hide": _vm.$root.closeLightbox
    },
    scopedSlots: _vm._u([{
      key: "prev-btn",
      fn: function(props) {
        return [_c('div', {
          staticClass: "vel-shift-btn vel-prev",
          on: {
            "click": function($event) {
              return _vm.$root.shiftLightboxImage(-1)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("navigate_before")])])]
      }
    }, {
      key: "next-btn",
      fn: function(props) {
        return [_c('div', {
          staticClass: "vel-shift-btn vel-next",
          on: {
            "click": function($event) {
              return _vm.$root.shiftLightboxImage(1)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("navigate_next")])])]
      }
    }, {
      key: "toolbar",
      fn: function(props) {
        return [_c('div', {
          staticClass: "vel-toolbar"
        }, [_c('button', {
          staticClass: "toolbar-btn",
          attrs: {
            "disabled": _vm.$root.ui.isLoading('rotateImage')
          },
          on: {
            "click": props.toolbarMethods.zoomIn
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("zoom_in")])]), _vm._v(" "), _c('button', {
          staticClass: "toolbar-btn",
          attrs: {
            "disabled": _vm.$root.ui.isLoading('rotateImage')
          },
          on: {
            "click": props.toolbarMethods.zoomOut
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("zoom_out")])]), _vm._v(" "), _c('button', {
          staticClass: "toolbar-btn",
          attrs: {
            "disabled": _vm.$root.ui.isLoading('rotateImage')
          },
          on: {
            "click": function($event) {
              return _vm.$root.rotateLightBoxImage(-90)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("rotate_right")])]), _vm._v(" "), _c('button', {
          staticClass: "toolbar-btn",
          attrs: {
            "disabled": _vm.$root.ui.isLoading('rotateImage')
          },
          on: {
            "click": function($event) {
              return _vm.$root.rotateLightBoxImage(90)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("rotate_left")])])])]
      }
    }])
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cssload-thecube"
  }, [_c('div', {
    staticClass: "cssload-cube cssload-c1"
  }), _vm._v(" "), _c('div', {
    staticClass: "cssload-cube cssload-c2"
  }), _vm._v(" "), _c('div', {
    staticClass: "cssload-cube cssload-c4"
  }), _vm._v(" "), _c('div', {
    staticClass: "cssload-cube cssload-c3"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2770b0b4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./reports/assets/src/App.vue
// module id = 64
// module chunks = 0